import React from 'react'

const Walk = (props) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48' {...props}>
      <title>Walking Person</title>
      <path
        d='M27 10.3Q25.5 10.3 24.425 9.225Q23.35 8.15 23.35 6.65Q23.35 5.15 24.425 4.075Q25.5 3 27 3Q28.5 3 29.575 4.075Q30.65 5.15 30.65 6.65Q30.65 8.15 29.575 9.225Q28.5 10.3 27 10.3ZM13.9 46 19.75 16.55 14.65 18.85V25.5H11.6V16.85L21.2 12.8Q22.6 12.2 24.225 12.5Q25.85 12.8 26.7 14.05L28.8 17.35Q30.1 19.45 32.375 20.975Q34.65 22.5 37.65 22.5V25.5Q34.3 25.5 31.675 23.975Q29.05 22.45 26.8 19.4L24.75 27.2L29.35 31.35V46H26.35V34L20.95 29.1L17 46Z'
        fill='currentColor'
      />
    </svg>
  )
}

export default React.memo(Walk)
